import BaseTabButtons from "@PegasusCore/pegasus-one-tab-buttons/src/script";

class TabButtons extends BaseTabButtons {
    tabContainer = null;
    tabOverflow = false;
    tabOverflowStart = true;
    tabOverflowEnd = false;

    init() {
        super.init();

        this.tabContainer = this.$el.querySelector(
            ".TabButtons__container > div"
        );

        if (this.tabContainer != null) {
            this.tabContainer.addEventListener("scroll", (event) => {
                setTimeout(() => {
                    this.checkTabPosition();
                }, 500);
            });

            pegasus.onResizeFinished(() => {
                this.checkTabPosition();
            }, true);
        }
    }

    scrollTabContent(targetID) {
        this.$dispatch("pegasus-tab-content-selected", {
            targetID: targetID,
            tabGroup: JSON.stringify(this.tabButtons),
        });
    }

    checkTabPosition() {
        this.tabOverflow =
            this.tabContainer.scrollWidth > this.tabContainer.clientWidth;

        this.tabOverflowStart = this.tabContainer.scrollLeft <= 5;
        this.tabOverflowEnd =
            this.tabContainer.scrollLeft >=
            this.tabContainer.scrollWidth - this.tabContainer.clientWidth - 5;
    }

    scrollTabsLeft() {
        if (!this.tabOverflowEnd) {
            this.tabContainer.scrollLeft += 150;
        }

        setTimeout(() => {
            this.checkTabPosition();
        }, 500);
    }

    scrollTabsRight() {
        if (!this.tabOverflowStart) {
            this.tabContainer.scrollLeft -= 150;
        }
        setTimeout(() => {
            this.checkTabPosition();
        }, 500);
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("tabButtons", () => new TabButtons());
});
